import React, { useEffect, useState } from "react";
import { LoansTable } from "./AccountSummary";
import useBorrowerDashboardTwo from "./apis/useBorrowerDashboardTwo";
import { useDispatch, useSelector } from "react-redux";
import { fetchBorrowerPortfolioLoans } from "../../../store/reducers/dashboardSlice/api";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import { ArrowLeft } from "react-bootstrap-icons";

const BorrowerLoansTable = () => {
  const [category, setCategory] = useState("active");
  const [title, setTitle] = useState("Total Active Loans");
  const data = useSelector(
    (state) => state.dashboard.borrowerPortfolioLoans.data
  );
  const status = useSelector(
    (state) => state.dashboard.borrowerPortfolioLoans.status
  );
  const {
    paidoffAccountList,
    totalAccountList,
    activeAccountList,
    foreclosureLoansList,
  } = useBorrowerDashboardTwo();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (category === "active" && activeAccountList?.length) {
      dispatch(
        fetchBorrowerPortfolioLoans({
          requestBody: {
            borrowerRecID: activeAccountList?.map((el) => el.value).join(" "),
          },
        })
      );
    } else if (category === "total") {
      dispatch(
        fetchBorrowerPortfolioLoans({
          requestBody: {
            borrowerRecID: totalAccountList?.map((el) => el.value).join(" "),
          },
        })
      );
    } else if (category === "paidOff") {
      dispatch(
        fetchBorrowerPortfolioLoans({
          requestBody: {
            borrowerRecID: paidoffAccountList?.map((el) => el.value).join(" "),
          },
        })
      );
    } else if (category === "foreclosure") {
      dispatch(
        fetchBorrowerPortfolioLoans({
          requestBody: {
            borrowerRecID: foreclosureLoansList
              ?.map((el) => el.value)
              .join(" "),
          },
        })
      );
    }
  }, [
    category,
    paidoffAccountList?.length,
    totalAccountList?.length,
    activeAccountList?.length,
    foreclosureLoansList?.length,
  ]);

  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <div className="p-4 pb-0  mt-1 mb-5">
            <h6>
              <span
                className="linkClick"
                role="button"
                onClick={() => navigate(-1)}
              >
                <ArrowLeft size={20} /> Back
              </span>{" "}
              / Loans
            </h6>
          </div>
        </article>

        <article className="container-fluid row">
          <div className="d-flex gap-5 py-3">
            {summaryData.map((el) => (
              <Form.Check // prettier-ignore
                type={"radio"}
                id={`${el.label}`}
                label={`${el.label}`}
                checked={el.field === category}
                onChange={() => {
                  setCategory(el.field);
                  setTitle(el.label);
                }}
              />
            ))}
          </div>
          <LoansTable data={data} status={status} title={title} />
        </article>
      </section>
    </div>
  );
};

export default BorrowerLoansTable;

const summaryData = [
  { field: "active", label: "Active Loans", color: "text-primary" },
  { field: "total", label: "Total Loan Count", color: "text-primary" },
  { field: "paidOff", label: "Paid off Loans", color: "text-primary" },
  {
    field: "foreclosure",
    label: "Loans in Foreclosure",
    color: "text-primary",
  },
];
